import { message } from '@surecompanies/core_components'
import { useCallback, useState } from 'react'
import type { MappingRule, ParsedFile } from '../types'
import { buildDefaultRules } from '../utils/defaultColumns'
import { parseFile } from '../utils/fileParser'

export default function useFileUpload(
  onRulesGenerated: (rules: MappingRule[]) => void
) {
  const [parsedFile, setParsedFile] = useState<ParsedFile | null>(null)
  const sourceColumns = parsedFile?.columns ?? []

  const uploadFile = useCallback(
    async (file: File) => {
      try {
        const result = await parseFile(file)
        setParsedFile(result)

        const defaultRules = buildDefaultRules(result.columns)
        onRulesGenerated(defaultRules)

        message.success(
          `Loaded ${result.recordCount} records: ${result.columnCount} columns found`
        )
      } catch (err) {
        message.error(
          err instanceof Error ? err.message : 'Failed to parse file'
        )
      }
    },
    [onRulesGenerated]
  )

  const resetFile = useCallback(() => {
    setParsedFile(null)
  }, [])

  return {
    parsedFile,
    sourceColumns,
    uploadFile,
    resetFile,
  }
}
